import React from 'react';
import PropTypes from 'prop-types';
import ReportForm from './ReportForm';
import FiltersNavbarWrapper from '../../Components/Filters/FiltersNavbarWrapper';

const FiltersNavbar = function FiltersNavbar({
  currentFilters,
  isDataLimited,
  setCurrentFilters = () => {},
  open = true,
  toggle = () => {},
  isOperator = false,
  hideOperatorFilter = false,
  title = '',
  sectionsOptions = [],
  switchLabel = '',
  onSwitchClick = undefined,
  switchValue = false,
  wavePeriodOption = false,
}) {
  return (
    <FiltersNavbarWrapper
      currentFilters={currentFilters}
      setCurrentFilters={setCurrentFilters}
      open={open}
      onToggle={toggle}
      switchLabel={switchLabel}
      onSwitchClick={onSwitchClick}
      switchValue={switchValue}
      isOperator={isOperator}
      title={title}
    >
      <ReportForm
        isOperator={isOperator}
        currentFilters={currentFilters}
        setCurrentFilters={setCurrentFilters}
        isDataLimited={isDataLimited}
        hideOperatorFilter={hideOperatorFilter}
        sectionsOptions={sectionsOptions}
        wavePeriodOption={wavePeriodOption}
      />
    </FiltersNavbarWrapper>
  );
};

FiltersNavbar.propTypes = {
  currentFilters: PropTypes.object.isRequired,
  setCurrentFilters: PropTypes.func,
  open: PropTypes.bool,
  toggle: PropTypes.func,
  isOperator: PropTypes.bool,
  isDataLimited: PropTypes.bool,
};
export default FiltersNavbar;
